import { render } from "./PledgeTotalField.vue?vue&type=template&id=6132743a"
import script from "./PledgeTotalField.vue?vue&type=script&lang=js"
export * from "./PledgeTotalField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__